import { useHistory, useRouteMatch } from 'react-router-dom';

function urlSafeEncode(str: string) {
  return str
    .split('')
    .map(char => char.charCodeAt(0).toString(16).padStart(2, '0'))
    .join('');
}

function urlSafeDecode(hex: string) {
  return (
    hex
      .match(/.{2}/g)
      ?.map(char => String.fromCharCode(parseInt(char, 16)))
      .join('') || ''
  );
}

type Params = {
  uuid: string;
};
export const useReservationId = () => {
  const {
    params: { uuid },
  } = useRouteMatch<Params>();
  const history = useHistory();
  const queryParam = new URLSearchParams(window.location.search).get('reservationId');
  const param = uuid || queryParam;
  return {
    reservationId: param ? urlSafeDecode(param) : '',
    encode: (id: string) => urlSafeEncode(id),
    push: (route: string, reservationId?: string) =>
      reservationId ? history.push(route.replace(':uuid', urlSafeEncode(reservationId))) : history.push(route),
    decode: (id: string) => urlSafeDecode(id),
  };
};
